<template>
  <div id="appFooter" :style="{'background-color': primaryColor}">
    footer
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'appFooter',
  computed: {
    ...mapGetters([
      'primaryColor'
    ])
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../../../styles/variable.scss';
  #appFooter {
    height: 30px;
    line-height: 30px;
    width: 100%;
    color: $footerTextColor;
    text-align: center;
    position: fixed;
    bottom: 0;
    z-index: 999999;
  }
</style>



// WEBPACK FOOTER //
// src/views/firmiana/home/footer.vue